import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./LoginForm.css";

export default function LoginForm({ title, requiredUserType, homePath }) {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    try {
      const data = await login(email, password);

      if (data.userType !== requiredUserType) {
        setError("This account is not authorized to access this area.");
        localStorage.removeItem("bigmarket_auth");
        localStorage.removeItem("bigmarket_token");
        window.location.reload();
        return;
      }

      navigate(homePath, { replace: true });
    } catch (err) {
      console.log("Login error:", err);
      console.log("Login error response:", err.response);
      console.log("Login error response.data:", err.response?.data);

      if (!err.response) {
        setError(`Could not reach the server (${err.message}). Check the API base URL and that the backend is running.`);
        return;
      }

      const message = err.response.data?.title || err.response.data;
      setError(typeof message === "string" ? message : "Login failed.");
    }
  }

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <h1>{title}</h1>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />

        {error && <p className="login-error">{error}</p>}

        <button type="submit" disabled={loading}>
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
